import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { TranslatePipe } from '../../../translate/translate.pipe';
import { TranslateService } from '../../../translate/translate.service';
import { PagamentiDTO } from '../../models/pagamento-dto';

@Component({
  selector: 'lib-visualizza-dettagli',
  templateUrl: './visualizza-dettagli.component.html',
  styleUrls: ['./visualizza-dettagli.component.css'],
  styles: [`
  ::ng-deep .detail-pagamenti > .mat-expansion-indicator:after {
    color: white;
    margin-top: -3px;
  }
`],
})
export class VisualizzaDettagliComponent implements OnInit {
  @Input()
  pagamento: PagamentiDTO;
  dettagli: string;
  data: string;
  numeroRighe: string

  constructor(private traduzione: TranslatePipe) { }

  ngOnInit(): void {
    this.dettagli = this.traduzione.transform('visualizzaDettagli');
    this.data = this.pagamento.dataValuta != null ?
      moment(new Date(this.pagamento.dataValuta)).format("DD/MM/YYYY") : '';
    this.contaRighe();
  }

  accordionOpened() {
    this.dettagli = this.traduzione.transform('nascondiDettagli');
  }
  accordionClosed() {
    this.dettagli = this.traduzione.transform('visualizzaDettagli');
  }
  contaRighe() {
    if (this.pagamento.motivoScarto) {
      let par = this.pagamento.motivoScarto;
      par = par.replace(/(^\s*)|(\s*$)/gi, "");
      par = par.replace(/[ ]{2,}/gi, " ");
      par = par.replace(/\n /, "\n");
      let numeroRighe = par.split('').length / 180;
      this.numeroRighe = Math.ceil(numeroRighe).toString()
    }
  }
}
